import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Switch } from "./Switch";
import { Messaggio } from "../components/tools/Messaggio";
import { Snackbar } from "../components/tools/Snackbar";

export const App = () => (
  <>
    <BrowserRouter>
      <Messaggio />
      <Snackbar />
      <Switch />
    </BrowserRouter>
  </>
);
